import React from 'react'
import Link from 'gatsby-link'
import { breakpoints, colors, distances } from '../styles/variables'
import Arrow from '../images/Arrow.js'

const transition = '.2s cubic-bezier(0, 0, 0, 1)'

export default ({ title, meta, content, moreLabel, slug, image }) => (
  <Link
    css={{
      alignItems: 'flex-end',
      background: image
        ? `url(${image.childImageSharp.fluid.src})`
        : colors.orange,
      backgroundPosition: '50%',
      backgroundSize: 'cover',
      borderRadius: 3,
      color: colors.grey.medium,
      cursor: 'pointer',
      display: image ? 'flex' : 'block',
      flexGrow: 1,
      margin: `0 ${distances.gridMargin.small}px ${
        distances.gridMargin.small
      }px 0`,
      minHeight: image ? 285 : 0,
      padding: 30,
      position: 'relative',
      overflow: 'hidden',
      textDecoration: 'none',
      transition: `background ${transition}, color ${transition}, transform ${transition}`,
      width: '100%',
      '@media(min-width: 750px)': {
        maxWidth: `calc(50% - ${distances.gridMargin.small}px)`,
        width: `calc(${100 / 2}% - ${distances.gridMargin.small}px)`,
      },
      [breakpoints.fullGrid]: {
        margin: `0 ${distances.gridMargin.large}px ${
          distances.gridMargin.large
        }px 0`,
        maxWidth: `calc(50% - ${distances.gridMargin.large}px)`,
        width: `calc(${100 / 3}% - ${distances.gridMargin.large}px)`,
      },
      'h3, span': {
        transition: `color ${transition}`,
      },
      path: {
        transition: `fill ${transition}`,
      },
      ':hover': image
        ? {
            transform: 'scale(1.05)',
          }
        : {
            background: colors.primary,
            color: 'white',
            transform: 'scale(1.05)',
            'h3, span, p': {
              color: 'white',
            },
            path: {
              fill: 'white',
            },
          },
    }}
    to={slug}
  >
    {image && (
      <div
        css={{
          background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, .6))',
          height: '100%',
          left: 0,
          position: 'absolute',
          top: 0,
          width: '100%',
        }}
      />
    )}
    <h3
      css={
        meta || (!content && !moreLabel)
          ? {
              color: image ? 'white' : '',
              margin: 0,
              zIndex: 1,
            }
          : {
              marginBottom: '0.5em',
            }
      }
    >
      {title}
    </h3>
    {meta && (
      <p
        css={{
          color: colors.grey.light,
          fontSize: '0.875em',
          marginBottom: 15,
        }}
      >
        {meta}
      </p>
    )}
    {content && (
      <p
        css={{
          marginBottom: '1em',
        }}
      >
        {content}
      </p>
    )}
    {moreLabel && (
      <span
        css={{
          color: colors.primary,
          fontFamily: 'Quicksand, sans-serif',
          fontWeight: 800,
          lineHeight: '2em',
          textDecoration: 'none',
          '> svg': { marginLeft: 10 },
        }}
      >
        {moreLabel}
        <Arrow />
      </span>
    )}
  </Link>
)
